import React from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function NotFound() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="text-center p-5">
          <img
            src="/assets/img/404.png"
            alt="404 - Page Not Found"
            className="img-fluid mb-2"
            style={{ maxWidth: "500px" }}
          />
          <h1>Page Not Found</h1>
          <p>Sorry, the page you are looking for does not exist.</p>
          <Link to="/" className="btn-style1">
            Go Back Home
          </Link>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default NotFound;